module.exports = __webpack_public_path__ + "img/Falkberget_Den_fjerde_nattevakt.ad81a9d2.jpg";